<!-- Modal Header (only show when used as modal) -->
<div class="modal-header" *ngIf="!isInline">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<!-- Inline Header (only show when used inline) -->
<div *ngIf="isInline" style="padding: 15px; border-bottom: 1px solid #dee2e6; background-color: #f8f9fa; position: relative;">
  <h4 class="modal-title">{{ title }}</h4>
  
  <!-- Zoom Controls (only for inline mode) -->
  <div class="zoom-controls" style="position: absolute; height: 68%; top: 100px; right: 10px; display: flex; flex-direction: row; gap: 5px; background: rgba(255, 255, 255, 0.9); padding: 5px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
    <button type="button" (click)="zoomIn()" [disabled]="zoomLevel >= maxZoom" [style.opacity]="zoomLevel >= maxZoom ? '0.5' : '1'" style="background: #1A73EB; color: white; border: none; border-radius: 4px; width: 24px; height: 24px; cursor: pointer; font-size: 16px; display: flex; align-items: center; justify-content: center; line-height: 1;" title="Zoom In">+</button>
    <button type="button" (click)="zoomOut()" [disabled]="zoomLevel <= minZoom" [style.opacity]="zoomLevel <= minZoom ? '0.5' : '1'" style="background: #1A73EB; color: white; border: none; border-radius: 4px; width: 24px; height: 24px; cursor: pointer; font-size: 16px; display: flex; align-items: center; justify-content: center; line-height: 1;" title="Zoom Out">−</button>
    <button type="button" (click)="resetZoom()" [disabled]="zoomLevel === 1 && panX === 0 && panY === 0" [style.opacity]="(zoomLevel === 1 && panX === 0 && panY === 0) ? '0.5' : '1'" style="background: #1A73EB; color: white; border: none; border-radius: 4px; width: 24px; height: 24px; cursor: pointer; font-size: 14px; display: flex; align-items: center; justify-content: center; line-height: 1;" title="Reset Zoom">⌂</button>
  </div>
</div>
<div [class]="isInline ? 'inline-body' : 'modal-body'" 
     [style]="isInline ? 'text-align: center; padding: 20px; max-height: calc(100vh - 200px); overflow: auto; position: relative;' : 'text-align: center; padding: 20px; max-height: 80vh; overflow: auto; position: relative;'"
     (wheel)="onWheel($event)"
     (mousedown)="onMouseDown($event)"
     (mousemove)="onMouseMove($event)"
     (mouseup)="onMouseUp($event)"
     (mouseleave)="onMouseUp($event)">
  <!-- File Upload Section (only shown when allowUpload is true) -->
  <div *ngIf="allowUpload" class="upload-section" style="margin-bottom: 20px;">
    <input 
      type="file" 
      id="fileInput" 
      #fileInput
      (change)="onFileSelected($event)"
      accept="image/*,.pdf,.doc,.docx"
      style="display: none;" />
    <button 
      type="button" 
      class="btn btn-primary"
      (click)="fileInput.click()"
      style="margin-bottom: 15px;">
      {{ selectedFile ? 'Change Image' : 'Upload Image' }}
    </button>
    <div *ngIf="selectedFile" class="4selected-file-info" style="margin-top: 10px; color: #666; font-size: 14px;">
      Selected: {{ selectedFile.name }} ({{ (selectedFile.size / 1024).toFixed(2) }} KB)
    </div>
  </div>

  <!-- PDF/DOC Viewer using Google Docs Viewer -->
  <div *ngIf="(isPdfFile(getDisplayUrl()) || isDocFile(getDisplayUrl())) && !shouldShowPdfAsImage() && (previewUrl || imageUrl)" style="width: 100%; height: 70vh; border: 1px solid #ddd; border-radius: 4px; overflow: hidden; position: relative;">
    <div *ngIf="isLoading" style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999;">
      Loading document...
    </div>
    <!-- Google Docs Viewer -->
    <iframe 
      *ngIf="!isLoading && googleDocsViewerUrl"
      [src]="googleDocsViewerUrl" 
      style="width: 100%; height: 100%; border: none;"
      frameborder="0">
    </iframe>
    <!-- Fallback to direct PDF viewer if Google Docs viewer fails -->
    <div *ngIf="!isLoading && !googleDocsViewerUrl && pdfUrl" style="width: 100%; height: 100%;">
      <object 
        [data]="pdfUrl" 
        type="application/pdf" 
        style="width: 100%; height: 100%; border: none;">
        <embed 
          [src]="pdfUrl" 
          type="application/pdf" 
          style="width: 100%; height: 100%;" />
        <p style="padding: 20px;">Your browser does not support PDFs. 
          <a [href]="getDisplayUrl()" target="_blank" (click)="$event.stopPropagation()">Click here to view the document</a>.
        </p>
      </object>
    </div>
  </div>
  
  <!-- PDF Preview as Image (rendered PNG from PDF.js) -->
  <div *ngIf="shouldShowPdfPreviewImage() && pdfPreviewImageUrl" style="width: 100%; max-height: 70vh; border: 1px solid #ddd; border-radius: 4px; overflow: auto; text-align: center;">
    <div [style.transform]="'scale(' + zoomLevel + ') translate(' + panX + 'px, ' + panY + 'px)'"
         [style.transform-origin]="'50% 50%'"
         [style.transition]="isDragging ? 'none' : 'transform 0.1s ease-out'"
         style="display: inline-block; cursor: grab;"
         [style.cursor]="isDragging ? 'grabbing' : (zoomLevel > 1 ? 'grab' : 'default')">
      <img 
        [src]="pdfPreviewImageUrl" 
        style="max-width: 100%; max-height: 70vh; object-fit: contain; display: block; margin: 0 auto;" 
        [alt]="title + ' preview'" />
    </div>
  </div>

  <!-- PDF Preview (for uploaded PDFs - blob URLs, fallback to object tag) -->
  <div *ngIf="shouldShowPdfAsImage() && !shouldShowPdfPreviewImage() && pdfImageUrl" style="width: 100%; height: 70vh; border: 1px solid #ddd; border-radius: 4px; overflow: hidden;">
    <object 
      [data]="pdfImageUrl" 
      type="application/pdf" 
      style="width: 100%; height: 100%; border: none; display: block;">
      <embed 
        [src]="pdfImageUrl" 
        type="application/pdf" 
        style="width: 100%; height: 100%;" />
      <p style="padding: 20px; text-align: center; color: #999;">
        PDF preview not supported in your browser. 
        <a [href]="getDisplayUrl()" target="_blank" (click)="$event.stopPropagation()">Download PDF</a>
      </p>
    </object>
  </div>

  <!-- Image Viewer -->
  <div *ngIf="!isPdfFile(getDisplayUrl()) && !isDocFile(getDisplayUrl()) && !shouldShowPdfAsImage() && (previewUrl || imageUrl) && !imageLoadError">
    <div [style.transform]="'scale(' + zoomLevel + ') translate(' + panX + 'px, ' + panY + 'px)'"
         [style.transform-origin]="'50% 50%'"
         [style.transition]="isDragging ? 'none' : 'transform 0.1s ease-out'"
         style="display: inline-block; cursor: grab;"
         [style.cursor]="isDragging ? 'grabbing' : (zoomLevel > 1 ? 'grab' : 'default')">
      <img 
        [src]="getSanitizedImageUrl()" 
        (error)="onImageError()"
        style="max-width: 100%; max-height: 70vh; object-fit: contain; border: 1px solid #ddd; border-radius: 4px;" 
        [alt]="title" />
    </div>
  </div>
  
  <!-- Image Load Error Message -->
  <div *ngIf="imageLoadError" class="no-image-message" style="padding: 40px; color: #dc3545;">
    <p style="font-weight: bold; margin-bottom: 10px;">Failed to load image</p>
    <p style="font-size: 14px; color: #666;">The file may not be available or the URL is invalid.</p>
    <p style="font-size: 12px; color: #999; margin-top: 10px;">File: {{ title }}</p>
  </div>

  <!-- No Image/File Message -->
  <div *ngIf="!previewUrl && !imageUrl && !allowUpload" class="no-image-message" style="padding: 40px; color: #999;">
    No image to display
  </div>
  <div *ngIf="allowUpload && !previewUrl && !imageUrl" class="no-image-message" style="padding: 40px; color: #999;">
    Please upload an image to preview
  </div>
</div>


